import { Box, chakra } from "@chakra-ui/react";
import { colours, fonts } from "@shared/ui.design-system";
import { ChevronLeftIcon, ChevronRightIcon } from "@shared/ui.icons";

export const Summary = chakra(Box, {
  baseStyle: {
    display: "flex",
    flexDirection: "row",
    fontFamily: fonts.medium,
    fontSize: "0.937rem"
  }
});

export const Paging = chakra(Box, {
  baseStyle: {
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
    fontFamily: fonts.medium,
    fontSize: "0.937rem"
  }
});

interface Props {
  itemsLength: number;
  page: number;
  totalPages: number;
  next: () => void;
  prev: () => void;
  listType: string;
  pageStart: number;
  pageEnd: number;
}

export const Pagination: React.FC<Props> = ({
  itemsLength,
  pageStart,
  pageEnd,
  page,
  next,
  totalPages,
  prev,
  listType
}) => {
  return itemsLength ? (
    <Box display="flex" alignItems="center" alignContent="center">
      <Summary my="1.25rem">
        {`Displaying ${listType} ${pageStart} - ${pageEnd} of ${itemsLength}`}
      </Summary>
      <Paging ml="1.25rem">
        <button
          type="button"
          aria-label="previous page"
          onClick={prev}
          title="Navigate to the previous page"
        >
          <ChevronLeftIcon
            color={colours.primary.dark}
            cursor={page === 1 ? "default" : "pointer"}
          />
        </button>
        {page} - {totalPages}
        <button
          type="button"
          aria-label="next page"
          onClick={next}
          title="Navigate to the next page"
        >
          <ChevronRightIcon
            color={colours.primary.dark}
            cursor={page === totalPages ? "default" : "pointer"}
          />
        </button>
      </Paging>
    </Box>
  ) : null;
};
